<template>
  <transition name="fade" mode="out-in" appear>
    <template v-if="longDescriptionKey">
      <section v-if="mini" class="flex">
        <router-link :to="{ name }" :title="$tt(`common.navigationCard_${name}_thumbnail`)" role="button">
          <div class="tile navigation-mini-card-image">
            <div v-if="isIE11">
              <svg
                focusable="false"
                width="55px"
                height="55px"
                viewBox="0 0 100 100"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <filter id="svgDesaturate">
                    <feColorMatrix in="SourceGraphic" type="saturate" :values="isTelekom ? 1 : 0" result="A" />
                  </filter>
                </defs>
                <image x="0" y="0" width="100" height="100" filter="url(#svgDesaturate)" :xlink:href="image" :alt="shortDescription" />
              </svg>
            </div>
            <div v-else>
              <img :src="image" :alt="shortDescription" class="mini-card-image" />
            </div>
          </div>
        </router-link>

        <div class="flex-item" aria-hidden="true">
          <div class="offset-left-2 text-left" v-html="$t(`common.navigation_${name}`)" />
        </div>
      </section>
      <div v-else class="col-l-6 col-m-12">
        <div class="tile">
          <div class="navigation-card-canvas">
            <div class="tile-row">
              <div class="tile-cell">
                <div class="navigation-card-image h-ctr">
                  <router-link :to="{ name }" :title="$tt(`common.navigationCard_${name}`)" tabindex="-1" aria-hidden="true">
                    <div v-if="isIE11">
                      <svg
                        focusable="false"
                        width="100px"
                        height="100px"
                        viewBox="0 0 100 100"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <defs>
                          <filter id="svgDesaturate">
                            <feColorMatrix in="SourceGraphic" type="saturate" :values="isTelekom ? 1 : 0" result="A" />
                          </filter>
                        </defs>
                        <image x="0" y="0" width="100" height="100" filter="url(#svgDesaturate)" :xlink:href="image" />
                      </svg>
                    </div>
                    <div v-else>
                      <img :src="image" :alt="shortDescription" class="card-image" />
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="tile-row">
              <div class="tile-cell">
                <div class="navigation-card-longdescription h-ctr" v-html="$t(longDescriptionKey)"> </div>
              </div>
            </div>
            <div class="tile-row">
              <div class="tile-cell">
                <router-link
                  :to="{ name }"
                  class="btn btn-brand btn-block"
                  role="button"
                  :title="$tt(`common.navigationCard_${name}`)"
                  v-html="shortDescription"
                >
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { addOptionalSuffix } from '@/utils/i18n';

export default {
  name: 'NavigationCard',

  props: {
    name: {
      type: String,
      required: true,
    },

    mini: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    ...mapState('system', ['crm']),

    ...mapGetters('system', ['isTelekom']),

    longDescriptionKey() {
      const prefix = `common.navigationCard_${this.name}_longDescription`;
      return addOptionalSuffix(prefix, this.crm);
    },

    shortDescription() {
      return this.$tf(`common.navigationCard_${this.name}_shortDescription`);
    },

    image() {
      return require(`@/assets/images/home/${this.name.toLowerCase()}.svg`);
    },

    isIE11() {
      return !!window.MSInputMethodContext && !!document.documentMode;
    },
  },
};
</script>

<style scoped>
.tile-cell {
  padding-top: 12px;
}

.card-image {
  width: 100px;
  height: 100px;
}

.btn {
  padding: 6px 12px 7px;
}

.navigation-mini-card-image {
  padding: 12px 24px;
  margin: auto;
}

.mini-card-image {
  width: 55px;
  height: 55px;
  margin: 8px 0;
}

.flex {
  flex-wrap: nowrap;
  align-items: center;
}
</style>
